import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpContext, HttpContextToken } from '@angular/common/http';
import { TranslocoLoader, Translation } from '@ngneat/transloco';

export const SKIP_HTTP_ERROR = new HttpContextToken<boolean>(() => false);

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  constructor(private http: HttpClient) {}

  getTranslation(lang: string) {
    return this.http.get<Translation>(
      `assets/i18n/${lang}.json`
    );
  }
}
